import _ from 'lodash'
// import { removeHtmlTag } from '@/utils/index'
import { removeHtmlTag } from '@/utils'

// 触发规则 什么时候触发表单校验
const ruleTrigger = {
  INPUT: 'blur',
  INPUT_MAP: 'input',
  SELECT: 'change',
  RADIO: 'change',
  CHECKBOX: 'change',
  CASCADER: 'change',
  PROVINCE_CITY: 'change',
  DATE: 'change',
  MATRIX_SELECT: 'change',
  MATRIX_SCALE: 'change',
  MATRIX_INPUT: 'change'
}

// 验证身份证格式
/**
 * 验证身份证号码
 * @param { String } code 身份证号码
 */
function identityIDCard(code) {
  // 身份证号前两位代表区域
  const city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  const idCardReg = /^[1-9]\d{5}(19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i // 身份证格式正则表达式
  let errorMessage = '' // 错误提示信息
  let isPass = true // 身份证验证是否通过（true通过、false未通过）

  // 如果身份证不满足格式正则表达式
  if (!code) {
    isPass = false
  } else if (!code.match(idCardReg)) {
    isPass = false
  } else if (!city[code.substr(0, 2)]) {
    // 区域数组中不包含需验证的身份证前两位
    isPass = false
  } else if (code.length === 18) {
    // 18位身份证需要验证最后一位校验位
    code = code.split('')
    // ∑(ai×Wi)(mod 11)
    // 加权因子
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    // 校验位
    const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
    let sum = 0
    let ai = 0
    let wi = 0
    for (let i = 0; i < 17; i++) {
      ai = parseInt(code[i])
      wi = factor[i]
      sum += ai * wi // 开始计算并相加
    }
    const last = parity[sum % 11] // 求余
    if (last.toString() !== code[17]) {
      isPass = false
    }
  }
  return isPass
}

// 处理RADIO CHECKBOX 其他输入必填校验
const validateOtherInput = (rule, value, callback, formModel, cur) => {
  // 是否设置了必填
  if (false === cur.config.otherRequired) {
    callback()
  }
  if (Array.isArray(value)) {
    let flag = 0
    value.forEach((v) => {
      if (!formModel[`${rule.field}extension_${v}`]) flag += 1
    })
    if (flag > 0) {
      callback(new Error('请输入其他内容'))
    } else {
      callback()
    }
  } else {
    // 0 等于选中其他
    if (!formModel[`${rule.field}extension_${value}`]) {
      callback(new Error('请输入其他内容'))
    } else {
      callback()
    }
  }
}

// 校验矩阵输入
const validateMatrixInput = (rule, value, callback) => {
  let isValidate = true
  if (value) {
    // 值为嵌套对象
    if (!_.isArray(value) && _.isObject(value)) {
      _.keys(value).forEach((key1) => {
        // 是不是对象{a:{b:2,c:3}}
        let value1 = value[key1]
        // 矩阵填空
        if (!_.isArray(value1) && _.isObject(value1)) {
          _.keys(value1).forEach((key2) => {
            let value2 = value1[key2]
            if (!value2) {
              isValidate = false
              return
            }
          })
        }
      })
    }
    if (!isValidate) {
      callback(new Error('请输入全部矩阵组件的值'))
    } else {
      callback()
    }
  }
}
const validateMatrixSelect = (rule, value, callback, item) => {
  if (item.table.rows.length !== _.keys(value).length) {
    callback(new Error('请选择全部矩阵组件的值'))
  } else {
    callback()
  }
}

const validateMatrixScale = (rule, value, callback, item) => {
  if (item.table.rows.length > _.keys(value).length) {
    callback(new Error('请选择全部矩阵组件的值'))
  } else {
    item.table.rows.forEach((row) => {
      if (!value[row.id]) {
        callback(new Error('请选择全部矩阵组件的值'))
        return
      }
    })
    callback()
  }
}

const validateGoodsSelect = (rule, value, callback, item) => {
  if (value && Object.keys(value).length !== 0) {
    // value 是一个对象 key为选择商品的Id value为选择的数量 {'goodId001':2}
    let total = 0
    for (let key of Object.keys(value)) {
      total += value[key]
    }
    if (!total) {
      callback(new Error('最少选择一件商品'))
    }
  }
  callback()
}

export default {
  data() {
    return {}
  },
  methods: {
    buildRule(cur, rules) {
      const config = cur.config
      // 缓存服务端原始 regList，避免 buildRules 被多次调用时重复累积动态规则(required/validator)
      if (!Array.isArray(config.__baseRegList)) {
        config.__baseRegList = Array.isArray(config.regList) ? config.regList : []
      }
      config.regList = config.__baseRegList.slice()
      // 输入框校验
      this.handleInputValidate(cur, config)
      if (Array.isArray(config.regList)) {
        if (config.required) {
          // 矩阵系列组件 必填特殊处理 需要校验每项都有值
          this.handleSpecialRequired(cur, config)
          const required = {
            required: config.required,
            message: cur.placeholder
          }
          const label = removeHtmlTag(config.label)
          if (Array.isArray(config.defaultValue)) {
            required.type = 'array'
            required.message = `请至少选择一个${label}`
          }
          required.message === undefined && (required.message = `${label}不能为空`)
          config.regList.push(required)
        }
        rules[cur.vModel] = config.regList.map((item) => {
          item.pattern && (item.pattern = eval(item.pattern))
          item.trigger = ruleTrigger && ruleTrigger[cur.typeId]
          return item
        })
      }
      if (config.children) this.buildRules(config.children, rules)
    }, // 处理特殊组件非空校验
    handleSpecialRequired(cur, config) {
      // 矩阵系列组件 必填特殊处理 需要校验每项都有值
      let validator = null
      switch (cur.typeId) {
        case 'MATRIX_INPUT':
          validator = validateMatrixInput
          break
        case 'MATRIX_SELECT':
          validator = (rule, value, callback) => validateMatrixSelect(rule, value, callback, cur)
          break
        case 'MATRIX_SCALE':
          validator = (rule, value, callback) => validateMatrixScale(rule, value, callback, cur)
          break
        case 'RATE':
          validator = (rule, value, callback) => {
            if (!value || value === 0) {
              callback(new Error(cur.placeholder))
            } else {
              callback()
            }
          }
          break
        case 'SLIDER':
          validator = (rule, value, callback) => {
            if (!value || value === 0) {
              callback(new Error(cur.placeholder))
            } else {
              callback()
            }
          }
          break
        case 'CHECKBOX':
          validator = (rule, value, callback) => {
            if (cur.min && value.length < cur.min) {
              return callback(new Error(`最少选择${cur.min}项`))
            }
            if (cur.max && value.length > cur.max) {
              return callback(new Error(`最多选择${cur.max}项`))
            }
            callback()
          }
          break
        case 'RESERVE_TIME_RANGE':
        case 'RESERVE_DAY':
          validator = (rule, value, callback) => {
            console.log(value)
            if (!value || !Object.keys(value)) {
              return callback(new Error(`请选择`))
            }
            callback()
          }
          break
        case 'PROVINCE_CITY':
          validator = (rule, value, callback) => {
            if (Array.isArray(value) && value.length < 2) {
              return callback(new Error(`${cur.placeholder}`))
            }
            callback()
          }
          break
        case 'GOODS_SELECT':
          validator = (rule, value, callback) => validateGoodsSelect(rule, value, callback, cur)
          break
        default:
      }
      if (validator) {
        config.regList.push({ validator })
      }
    }, // 多选 单选 其他输入框特殊处理校验规则
    handleOtherInput(cur, config) {
      // 必填其他输入框校验
      if (['RADIO', 'CHECKBOX'].includes(cur.typeId)) {
        // 是否存在其他
        let flag = cur.config.options?.findIndex((o) => o.value === 0) > -1 && config.required
        const required = {
          validator: (rule, value, callback) => {
            validateOtherInput(rule, value, callback, this.formModel, cur)
          },
          message: cur.placeholder
        }
        if (flag) {
          config.regList.push(required)
        }
      }
    }, // 输入框常用校验处理
    handleInputValidate(cur, config) {
      // INPUT数据类型校验
      if (['INPUT'].includes(cur.typeId) && cur.config.dataType) {
        const rule = cur.config.dataType
        if (rule.type === 'phone') {
          config.regList.push({
            type: null,
            pattern: /^1[3456789]\d{9}$/,
            message: rule.message
          })
        } else if (rule.type === 'identity') {
          config.regList.push({
            validator: (rule, value, callback) => {
              if (value && !identityIDCard(value)) {
                callback(new Error('请输入正确身份证'))
              }
              callback()
            },
            message: rule.message
          })
        } else if (cur.minlength) {
          config.regList.push({
            validator: (rule, value, callback) => {
              if (!value || value.length < cur.minlength) {
                callback(new Error(`最少输入${cur.minlength}个字符`))
              }
              callback()
            }
          })
        } else {
          config.regList.push(rule)
        }
      }
    }
  }
}
